import { SoftwareState, initialState } from "../state/software.state";
import {
    SoftwareActions,
    GET_SOFTWARE_TYPES_SUCCESS,
    GET_SOFTWARE_CATEGORIES_SUCCESS
} from "../actions/software.action";

export function SoftwareReducer(
    state: SoftwareState = initialState,
    action: SoftwareActions
): SoftwareState {
    switch (action.type) {
        case GET_SOFTWARE_TYPES_SUCCESS: {
            return {
                ...state,
                softwareTypes: action.payload
            };
        }

        case GET_SOFTWARE_CATEGORIES_SUCCESS: {
            return {
                ...state,
                softwareCategories: action.payload
            };
        }

        default: return state;
    }
}
